import classNames from 'classnames';

import styles from './AuthPage.module.scss';
import '@components/mixins/commonStyles.scss';

import { LoginForm } from './components/LoginForm';
import { PasswordRecoveryForm } from './components/PasswordRecoveryForm';
import { useAuthForm } from './hooks/useAuthForm';
import { useAuthPageBootstrap } from './hooks/useAuthPageBootstrap';

export function AuthPage() {
    const {
        errorMessage,
        userErrorMessage,
        passwordErrorMessage,
        email,
        password,
        confirmPassword,
        passwordRecoveryMode,
        isBrowserAutofillCheckNeeded,
        applyBrowserAutofill,
        onBackButtonClick,
        onRecoveryClick,
        onLoginClick,
        onInputChange,
    } = useAuthForm();

    useAuthPageBootstrap({
        isBrowserAutofillCheckNeeded,
        onBrowserAutofillDetected: applyBrowserAutofill,
    });

    return (
        <div className={styles.root}>
            <div className={styles.form}>
                {!!errorMessage && (
                    <span className={classNames([styles.header, styles.errorMessage])}>{errorMessage}</span>
                )}
                <div className={classNames([styles.fieldWrapper, styles.smallMargin, 'font_h2'])}>
                    <span className={styles.message}>Chaika CMS</span>
                </div>
                {passwordRecoveryMode ? (
                    <PasswordRecoveryForm
                        password={password}
                        confirmPassword={confirmPassword}
                        passwordErrorMessage={passwordErrorMessage}
                        onInputChange={onInputChange}
                        onLoginClick={onLoginClick}
                        onBackButtonClick={onBackButtonClick}
                    />
                ) : (
                    <LoginForm
                        email={email}
                        password={password}
                        userErrorMessage={userErrorMessage}
                        passwordErrorMessage={passwordErrorMessage}
                        onInputChange={onInputChange}
                        onLoginClick={onLoginClick}
                        onRecoveryClick={onRecoveryClick}
                    />
                )}
            </div>
        </div>
    );
}
